import dayjs from "dayjs";
import { StyledFlex } from "../Table/index.styled";
import { memo, useEffect, useRef, useState } from "react";
import useIsVisible from "@lib/hooks/useVisible";
import _ from "lodash";

type Props = {
  date: Date | number;
  beforeDate?: string | JSX.Element;
  afterDate?: string | JSX.Element;
};

let interval: NodeJS.Timeout;

function FromNow(props: Props) {
  const { date, beforeDate, afterDate } = props;
  const target = useRef();
  const targetVisible = useIsVisible(target);
  const [fromNow, setFromNow] = useState<any>();

  useEffect(() => {
    setFromNow(dayjs(date).fromNow());

    if (targetVisible) {
      interval = setInterval(() => {
        setFromNow(dayjs(date).fromNow());
      }, 1000);
    } else {
      clearInterval(interval);
    }

    return () => {
      clearInterval(interval);
    };
  }, [targetVisible]);

  return (
    <StyledFlex ref={target}>
      {beforeDate}
      {fromNow}
      {afterDate}
    </StyledFlex>
  );
}

export default memo(FromNow, (prevProps, nextProps) => {
  return _.isEqual(prevProps, nextProps);
});
